import { configureStore } from '@reduxjs/toolkit'
import SalesOperationData from './operation/SaleDataOperation';
import LotData from './lots/LotData';
import SaleDataStore from './sales/SaleDataStore';

export const SalesAppDataStore = configureStore({
  reducer: {
    sales: SaleDataStore,
    lots: LotData,
    salesOperation: SalesOperationData,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      serializableCheck: false
  })
});

export const getSaleState = () => SalesAppDataStore.getState();
export const getCurrentSale = () => getSaleState().sales.currentSale;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type SalesAppState = ReturnType<typeof SalesAppDataStore.getState>

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type SalesAppDispatch = typeof SalesAppDataStore.dispatch